export const subscribeUser = async (email: string, topic: string, source: string) => {
  const apiKey = import.meta.env.VITE_MAILERLITE_API_KEY;
  
  // Validar que la API key esté configurada
  if (!apiKey) {
    console.warn('MailerLite API key no está configurada. Saltando suscripción a MailerLite.');
    return false;
  }

  const apiUrl = 'https://connect.mailerlite.com/api/subscribers';

  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    Authorization: `Bearer ${apiKey}`,
  };

  const params = {
    email,
    fields: {
      topic,
      source,
    },
    groups: ['157296989463119706'], // Dominicoders
    status: 'active',
  };

  const body = JSON.stringify(params);

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: body,
    });

    if (response.ok) {
      return true;
    } else {
      // Log detallado del error para debugging
      const errorData = await response.json().catch(() => ({ message: 'Error desconocido' }));
      console.error('Error en MailerLite:', {
        status: response.status,
        statusText: response.statusText,
        error: errorData
      });
      
      // Si es un error 401, la API key es inválida
      if (response.status === 401) {
        console.error('MailerLite API key inválida o expirada');
      }
      
      return false;
    }
  } catch (error) {
    console.error('Error al suscribir usuario en MailerLite:', error);
    return false;
  }
};
